import { $, addAction, INIT } from '@situation/setdesign.util';

addAction(INIT, () => {
    const transitionDelay = 1500;
    $('.delay-hide, .delay-hide-pseudo').each((_, el) => {
        const $el = $(el);
        setTimeout(() => {
            $el.addClass('delay-hide--hidden');
        }, transitionDelay);
    });
});
